import '@styles/components/appBimWindows.less';

const AppBimWindows = () => {
  return (
    <div className={'app-display-desc'}>
      <div>
        <div className={'content-introduction'}>
        “看模王”是一款集多功能于一体的BIM模型查看展示与处理软件，
        由跨世纪 软件倾力打造，依托自主研发的“跨界云空间”引擎，
        无缝融合BIM与GIS技术，实现从“看模”、”组模“、
        ”转模”到”秀模”的全方位解决方案。无论是大型建筑群还
        是复杂基础设施，无论是在云端协作还是本地单机操作，
        “看模王”都能确保您的 BIM模型得到高效利用和精彩呈现。
        </div>
        <img className={'bimw'} src={require('@images/home/bimw.png').default} alt="" />
      </div>
    </div>
  );
};

export default AppBimWindows;
